import React, { useState, useEffect, useContext } from 'react';
import { GeolocationContext, LanguageContext, WhiteLabelContext, AccountContext, WebappContext } from "ToolboxUtils/web/context/context";
import DestinationView from 'ToolboxComponents/webapp/pages/destination-view/destination-view';
import Loader from 'ToolboxComponents/commons/loader/loader';
import apiChuchoteurs from 'ToolboxUtils/web/api/api-chuchoteurs';
import useApiChuchoteurs from 'ToolboxUtils/web/hooks/use-api-chuchoteurs';
import useIsContentLoaded from 'ToolboxUtils/web/hooks/use-is-content-loaded';

import { PAGE_LOAD_WAITING } from 'Params/globals';

const Destination = props => {
  const [signIn, setSignIn] = useContext(WebappContext).usePath('modals.signIn');
  const [account, setAccount] = useContext(AccountContext).usePath();
  const [language] = useContext(LanguageContext).usePath();
  const [whiteLabel] = useContext(WhiteLabelContext).usePath();
  const [geolocation] = useContext(GeolocationContext).usePath();

  const [pageInitTime, setPageInitTime] = useState(Date.now());
  const [isLoaderCountDownSet, setLoaderCountDown] = useState(false);
  const [isLoaderDisplayed, showLoader] = useState(false);

  if (!isLoaderCountDownSet) {
    setLoaderCountDown(true);
    setTimeout(function(){
      if (!products.isComplete) {
        showLoader(true);
      }
    }, PAGE_LOAD_WAITING - (Date.now() - pageInitTime));
  }

  useEffect(() => {
    return () => {
      setLoaderCountDown(false);
      setPageInitTime(null);
    }
  }, []);

  const updateFav = id => {
    if (account.favorites.includes(id)) {
      const favorites = account.favorites.filter(favorite => favorite !== id);
      setAccount('favorites', favorites);
    } else {
      const favorites = account.favorites.concat([id]);
      setAccount('favorites', favorites);
    }
  }

  const openSignInModal = status => {
    setSignIn({opened: true, from: 'fav'});
  }

  const products = useApiChuchoteurs.get('/products', {
    params: {
      filter: 'majors',
      language,
      whiteLabelId: whiteLabel.id,
      isInZone: whiteLabel.isInZone,
      longitude: geolocation.coordinates.longitude,
      latitude: geolocation.coordinates.latitude
    },
    depends: geolocation && whiteLabel,
    noTrack: ['time']
  });

  const concierge = useApiChuchoteurs.get(`/concierges`, {
    params: {filter: 'closest', latitude: geolocation.coordinates.latitude, longitude: geolocation.coordinates.longitude, language, isInZone: whiteLabel.isInZone, whiteLabelId: whiteLabel.id},
    depends: geolocation && whiteLabel,
   });
  



  const isContentLoaded = products.isComplete && concierge.isComplete;
  useIsContentLoaded(isContentLoaded);

  return (
    <>    
      {products.isComplete && concierge.isComplete
        ? <DestinationView 
          products={products.data} 
          concierge={concierge.data[0]}
          addFavorite={async (id) => {
            if (account && account.id) {
              try {
                const favorite = await apiChuchoteurs.post(`/accounts/${account.id}/products/${id}/favorites`, {
                  token: localStorage.token
                })
                updateFav(id);
              } catch(err) {
                apiChuchoteurs.post(`/logs`, {
                  body: {error: {...err, type: 'front'}}
                })
              }
            } else {
              openSignInModal(true);
            }
          }}
          deleteFavorite={async (id) => {
            if (account && account.id) {
              try {
                const favorite = await apiChuchoteurs.delete(`/accounts/${account.id}/products/${id}/favorites`, {
                  token: localStorage.token
                })
                updateFav(id);
              } catch(err) {
                apiChuchoteurs.post(`/logs`, {
                  body: {error: {...err, type: 'front'}}
                })
              }
            } else {
              openSignInModal(true);
            }
          }}
          />
        : isLoaderDisplayed
          ? <Loader />
          : <></>
      }
    </>
  );
}

export default Destination;
